export default __webpack_public_path__ + "static/media/Name.a11db108.png";